export default __webpack_public_path__ + "static/media/Questions-amico.1c7812e3.png";